(function ($) {
  const initializeBlock = function ($block) {
    if (!$($block.closest('.acf-block-preview')).length) {
      const $testimonials = $block.find(".testimonials");
      if ($testimonials.hasClass("slick-initialized")) {
        $testimonials.slick("unslick");
      }

      $testimonials.slick({
        // prevArrow: '<button type="button" class="slick-arrow__btn slick-prev">&lsaquo;</button>',
        // nextArrow: '<button type="button" class="slick-arrow__btn slick-next">&rsaquo;</button>',
        arrows: false,
        dots: true,
        fade: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        swipe: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 8000,
      });
    }
  }

  $(document).ready(function () {
      $('.block--testimonials').each(function () {
          initializeBlock($(this));
      })
  })

  if (window.acf) {
      window.acf.addAction('render_block_preview/type=testimonials', initializeBlock);
  }

})(jQuery);